// import moment from 'moment'

export default {
  getCards (VueApp, token, callback) {
    let self = this
    VueApp.$sdk.get(VueApp, `/me/cards?token=${token}`, {}, r => {
      if (!r.error) {
        let cards = []
        r.list.forEach(card => {
          let className = self.parseCardClass(card)
          cards.push({
            id: card.ID,
            type: card.title,
            number: card.cardNumber,
            exp: card.cardExpires,
            className: className
          })
        })
        VueApp.$store.commit('cards/setCardData', {
          lastUserID: VueApp.$store.state.user.id,
          list: cards
        })
      }
      callback(r)
    })
  },
  parseCardClass (card) {
    let result = ''
    if (card.title === 'Visa') {
      result = 'visa'
    } else if (card.title === 'MasterCard' || card.title === 'Master Card') {
      result = 'mastercard'
    } else if (card.title === 'American Express') {
      result = 'amex'
    } else if (card.title === 'JCB') {
      result = 'jcb'
    } else if (card.title === 'Diners Club') {
      result = 'dinersclub'
    } else if (card.title === 'Discover') {
      result = 'discover'
    }
    return result
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/credit-card.js